module.exports = __webpack_public_path__ + "img/student_30.6ee38e66.png";